import React from 'react';

// Design System Components
import Typography from 'Components/DesignSystem/Typography/Typography';

interface SectionHeadingProps {
  children: string;
  /** Heading level; the pane's own sections are `h3`, panel sections `h4`. */
  as?: 'h3' | 'h4';
}

/**
 * The pane's section heading: small, bold, uppercase, widely tracked.
 *
 * The v3 prototype draws these in an uppercase monospace face. The emphasis and
 * density carry over — the face does not: this repo's design system sets its type
 * in Noto Sans and has no monospace heading style, and R64/R4 give the repo's own
 * tokens priority over a prototype literal.
 */
const SectionHeading = ({ children, as = 'h3' }: SectionHeadingProps) => (
  <Typography
    variant="sub-title-header"
    as={as}
    className="tw-text-ink-secondary tw-uppercase tw-tracking-wide"
  >
    {children}
  </Typography>
);

export default SectionHeading;
